var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInsurance = function SvgIconInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M25.593 5.717c0 14.058-9.041 18.55-10.791 19.366a.993.993 0 0 1-.584 0c-1.75-.816-10.791-5.25-10.791-19.366 0-2.1 3.966 1.458 10.616-2.684.292-.175.7-.175 1.05 0 2.509 1.634 4.725 2.217 6.417 2.275h4.083v.409Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m10.31 12.775 3.091 3.15 6.125-6.067"
  })));
};
export default SvgIconInsurance;